<template>
    <div class="sidebar">
        <el-menu
            class="sidebar-el-menu"
            :default-active="onRoutes"
            :collapse="collapse"
            text-color="rgba(0,0,0,0.6)"
            active-text-color="#2766FF"
            unique-opened
            router
        >
            <template v-for="item in NavBar">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon" class="iconfont"></i>
                            <span slot="title">{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">{{
                                    threeItem.title
                                }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                                <i :class="subItem.icon" class="iconfont"></i>
                                <template slot="title">{{ subItem.title }}</template>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon" class="iconfont"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
		<div class="collapse-btn" @click="collapseChage" style="font-size: 16px;">
		    <i v-if="!collapse" class="el-icon-31liebiao"></i>
		    <i v-else class="el-icon-31liebiao"></i>
		</div>
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            collapse: false
        };
    },
    computed: {
        ...mapState({
            NavBar: state => state.user.NavBar
        }),
        onRoutes() {
            if (this.$route.path.replace('/', '') == 'personManager') {
                return 'meetingManages';
            } else {
                return 'meetingManages';
				// return this.$route.path.replace('/', '');
            }
        }
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => {
            this.collapse = msg;
            bus.$emit('collapse-content', msg);
        });
    },
	methods: {
		// 侧边栏折叠
		collapseChage() {
			this.collapse = !this.collapse;
			bus.$emit('collapse', this.collapse);
		}
	},
};
</script>

<style lang="scss">
// .sidebar ::v-deep .el-menu-item span,
// .sidebar ::v-deep .el-submenu span {
//     font-size: 16px;
//     font-weight: bolder;
// }
.sidebar ::v-deep .el-menu--inline .el-menu-item {
    color: #747474;
}
</style>
<style scoped>
.iconfont {
    font-size: 23px;
    margin-right: 15px;
}
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 64px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
}
.sidebar > ul {
    height: 100%;
}
.collapse-btn {
	position: fixed;
	bottom: 10px;
	
	
		float: left;
		padding: 0 21px;
		cursor: pointer;
		line-height: 70px;
	}
</style>
